// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__K2Roa","title":"AfterImages90_title__2EYBe","images":"AfterImages90_images__3l2Ub"};